<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: "App",
  provide(){
    return {
      reload:this.reload
    }
  },
  data(){
    return{
        isRouterAlive:true
    }
  },
  methods:{
    reload(){
      this.isRouterAlive =  false;
      this.$nextTick(function(){
        this.isRouterAlive = true;
      })
    }
  }
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: absolute;
}
body {
  margin: 0;
  padding: 0;
}
/* element滚动条的隐藏横向滚动条(以下两条属性不加，其他的组件会出现不美观现象) */
.el-scrollbar__wrap {
  overflow-x: hidden !important;
  margin-bottom: 0px !important;
  overflow-y: scroll !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue